import { LOGO } from "../assets/images";

const APP_NAME = "Margot Okapi";
const APP_PRIMARY_COLOR = "#253da1";
const APP_SLOGAN =
  "This is a placeholder slogan. Have the client write something cool here.";
const APP_LOGO = LOGO;
const MARKT_ADDRESS = "https://markt-app.azurewebsites.net";
const DEV_DOMAIN = "localhost";
// const DOCS_LINK = "https://docs.margot-okapi.com/";
const DOCS_LINK = "https://docs.margot-okapi.com/docs/getting-started/create-products";

const MARKT_MONTHLY_MEMBERSHIP_ID = -4;

const SORT_DIRECTIONS = {
  ASCENDING: "ASC",
  DESCENDING: "DESC",
};

const DISPLAY_PER_PAGE = 25;

const ROLES = [
  { label: "System Administrator", value: 1 },
  { label: "Administrator", value: 2 },
];

const ROLE_IDS = {
  SYS_ADMIN: 1,
  ADMIN: 2
};

const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};

const SYS_TENANT_TABS = {
  PROFILE: "Profile Info",
  ACTIVITY: "Activity",
  NOTIFICATIONS: "Notifications",
  API_KEYS: "API Keys"
};

const PRODUCT_TYPE = {
  LICENSE: { label: "Primary License", value: 1},
  SUPPLEMENT: { label: "Feature Supplement", value: 2},
  // ITEM: { label: "Item", value: 3}
}

const PRODUCT_TYPES = [
  { label: "Select Product Type", value: undefined},
  PRODUCT_TYPE.LICENSE,
  PRODUCT_TYPE.SUPPLEMENT,
  // PRODUCT_TYPE.ITEM
];

// Product pricing models (values match TypeOfPricingModel enum ids: Flat=1, PerSeat=2).
// The admin SaveProduct endpoint binds a ProductDto whose PricingModel enum deserializes
// from these numeric ids (System.Text.Json default). (DEF-001)
const PRICING_MODEL = {
  Flat: { label: "Flat", value: 1 },
  PerSeat: { label: "Per Seat", value: 2 },
};

const PRICING_MODELS = [
  PRICING_MODEL.Flat,
  PRICING_MODEL.PerSeat,
];

const DURATION_TYPE = {
  Unknown: { label: "Unknown", value: 0},
  Minutes: { label: "Minutes", value: 5},
  Hours: { label: "Hours", value: 10},
  Days: { label: "Days", value: 15},
  Months: { label: "Months", value: 20},
  Years: { label: "Years", value: 30},
};

const DURATION_TYPES = [
  DURATION_TYPE.Unknown,
  DURATION_TYPE.Minutes,
  DURATION_TYPE.Hours,
  DURATION_TYPE.Days,
  DURATION_TYPE.Months,
  DURATION_TYPE.Years,
];

const DURATION_TYPES_OPT_PLURALITY = [
  { label: "Unknown", value: DURATION_TYPE.Unknown.value},
  { label: "Minute(s)", value: DURATION_TYPE.Minutes.value},
  { label: "Hour(s)", value: DURATION_TYPE.Hours.value},
  { label: "Day(s)", value: DURATION_TYPE.Days.value},
  { label: "Month(s)", value: DURATION_TYPE.Months.value},
  { label: "Year(s)", value: DURATION_TYPE.Years.value},
];

// TrialOffer discount modes (values match TypeOfDiscount enum ids)
const DISCOUNT_TYPE = {
  Fixed: { label: "Fixed", value: 1 },
  Percentage: { label: "Percentage", value: 2 },
};

const DISCOUNT_TYPES = [
  DISCOUNT_TYPE.Fixed,
  DISCOUNT_TYPE.Percentage,
];

// Behavioral offer types (values match TypeOfOffer enum ids:
// Entry=1, Retention=2, Reactivation=3, Loyalty=4, Seasonal=5, CrossSell=6, SeatExpansion=7, Custom=8).
// The admin SaveProduct endpoint binds a TrialOfferDto whose OfferType enum deserializes
// from these numeric ids (System.Text.Json default). (EVO-002)
const OFFER_TYPE = {
  Entry: { label: "Entry / Welcome", value: 1 },
  Retention: { label: "Retention / Save-at-Cancel", value: 2 },
  // SPR-009: Reactivation (3), Loyalty (4), SeatExpansion (7) RETIRED — inert in the engine and
  // removed from the admin picker. Enum values / DB columns retained; re-enable here to restore.
  // Reactivation: { label: "Reactivation / Win-back", value: 3 },
  // Loyalty: { label: "Loyalty", value: 4 },
  Seasonal: { label: "Seasonal", value: 5 },
  CrossSell: { label: "Cross-sell", value: 6 },
  // SeatExpansion: { label: "Seat expansion", value: 7 },
  Custom: { label: "Custom", value: 8 },
};

const OFFER_TYPES = [
  OFFER_TYPE.Entry,
  OFFER_TYPE.Retention,
  // SPR-009 retired — retained for reference:
  // OFFER_TYPE.Reactivation,
  // OFFER_TYPE.Loyalty,
  OFFER_TYPE.Seasonal,
  OFFER_TYPE.CrossSell,
  // OFFER_TYPE.SeatExpansion,
  OFFER_TYPE.Custom,
];

// TrialOffer discount APPLICATION mode (values match TypeOfDiscountMode enum ids: SingleTerm=1,
// RecurringPerPeriod=2). Mirrors OFFER_TYPE/OFFER_TYPES. The admin SaveProduct endpoint binds a TrialOfferDto
// whose DiscountMode enum deserializes from these numeric ids (System.Text.Json default). SingleTerm is the
// default so existing offers/behavior are unchanged. Descriptions carry the EVO-003 §2 "Good for" text. (EVO-003)
const DISCOUNT_MODE = {
  SingleTerm: {
    value: 1,
    label: "Single term",
    description:
      "One discounted block of the length set below, charged once, then renews at full price. Good for \"$1 for 3 months\" (one $1 block) or \"$0 for 14 days\".",
  },
  RecurringPerPeriod: {
    value: 2,
    label: "Recurring per period",
    description:
      "The discount applies to N consecutive billing periods at the product's own term, then reverts to full price. Good for \"20% off for 6 months\" or \"$1/month for 3 months\".",
  },
};

const DISCOUNT_MODES = [
  DISCOUNT_MODE.SingleTerm,
  DISCOUNT_MODE.RecurringPerPeriod,
];

const INTERVAL_TYPES = [
  { label: "Day", value: 1},
  { label: "Week", value: 2},
  { label: "Month", value: 3},
  { label: "Year", value: 4},
  { label: "YTD", value: 5},
];

const SALES_INTERVAL_TYPES = [
  { label: "30 Days", value: 1},
  { label: "60 Days", value: 2},
  { label: "90 Days", value: 3},
  { label: "Year", value: 4},
];

const SALES_INTERVAL_IDS = {
  THIRTY: 1,
  SIXTY: 2,
  NINETY: 3,
  YEAR: 4,
};

const MIME_TYPES = {
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  XLS: "application/vnd.ms-excel",
  PDF: "application/pdf",
  JPEG: "image/jpeg",
  PNG: "image/png",
  GIF: "image/gif",
};

const MAX_PAYMENT_TYPES = 3;

const US_TIMEZONES = [
  { label: "Eastern Standard Time", value: "Eastern Standard Time"},
  { label: "Central Standard Time", value: "Central Standard Time"},
  { label: "US Mountain Standard Time", value: "US Mountain Standard Time"},
  { label: "Mountain Standard Time", value: "Mountain Standard Time"},
  { label: "Pacific Standard Time", value: "Pacific Standard Time"},
  { label: "Alaskan Standard Time", value: "Alaskan Standard Time"},
];

const REGISTRATION_STEPS = {
  USER: {name: "User", seq: 1, label: "User"},
  ACCOUNT: {name: "Account", seq: 2, label: "Account"},
  SYSTEM_TENANT: {name: "SystemTenant", seq: 3, label: "System Tenant"},
  TERMS_AND_POLICY: {name: "TermsAndPolicy", seq: 4, label: "Terms and policy"},
};

const STEPS_LIST = [
  REGISTRATION_STEPS.USER,
  REGISTRATION_STEPS.ACCOUNT,
  REGISTRATION_STEPS.SYSTEM_TENANT,
  REGISTRATION_STEPS.TERMS_AND_POLICY
];

const REFUND_REASONS = [
  { label: "Requested By Customer", value: "RequestedByCustomer" },
  { label: "Duplicate", value: "Duplicate" },
  { label: "Fraudulent", value: "Fraudulent" },
];

const EXPLANATIONS = {
  Renew: `This defines the window of time prior to primary subscription expiration during which automatic renewal payments will be attempted.
      Say Jason's subscription expires on Friday morning at 8AM and he has indicated that he'd like to renew.
      We will begin attempting to process his payment on file per his intent this number of minutes prior to that expiration.
      If this setting is 1440 (aka 1 day) then the attempt to purchase the renewal subscription will occur a bit after 8AM on Thursday.
      It is recommended that at least 2 or 3 days of time be set here so that any payment issues can be corrected prior to license expiration. (Default set to 4 days)`,
  WarnCancel: `This defines the window of time prior to primary subscription expiration during which a pending expiration/cancellation notification will be sent to someone NOT intending to renew.
Say Jason's subscription expires on Friday morning at 8AM and he has indicated that he will not be renewing to any subscription product.
We may send a cancellation notification to him according to his defined preferences beginning at Monday at 8AM if this setting is 7200 (aka 5 days). (Default set to 7 days)`,
  WarnRenewal: `This defines the window of time prior to primary subscription expiration during which a pending renewal notification will be sent to someone intending to renew.
Say Jason's subscription expires on Friday morning at 8AM and he has indicated that he'd like to renew.
We may send a renewal notification to him according to his defined preferences beginning at Monday at 8AM if this setting is 7200 (aka 5 days).
Note that this warning of renewal notification will only ever be sent once, at most, per subscription renewal.
It is also necessary to choose a setting here that is more than the Process Renewal Minutes Threshold value because we no longer attempt to
warn of pending renewal once the renewal processing window threshold has passed.
For instance, if the Process Renewal Minutes Threshold is 3 days and the Warning of Renewal Minutes Threshold is 4 days only the 1 day of additional
anticipation time will be considered usable for sending the warning notification. (Default set to 7 days)`,
  Grace: `This is the number of extra minutes of access permitted after a primary subscription license has expired before the expired license is actually cancelled.
A scenario in which this would be relevant is a failed renewal payment.
Say Tom's payment instrument on file is declined when it was processed for a renewal 2880 minutes (aka 2 days) prior to its expiration.
(By the way, that 2880 minutes is the Process Renewal Threshold Minutes setting.) Tom will receive a delinquent notification and given a chance to
provide a working payment instrument for this period of time before he loses his subscription and his access.
Note that we will only re-attempt delinquent payments once every 24 hours. (Default set to 4 days)`,
  EmailNotification: `This is an email address used only when a notification or other processing failure occurs for this account. Email will be used preferentially if it is provided.`,
  MobileNotification: `This is a mobile phone number used only when a notification or other processing failure occurs for this account. Email will be used preferentially if it is provided.`,
  GetTenantUsers: `This is a defined API endpoint within the tenant's application that is called by ${APP_NAME} when tenant users are needed for notification purposes. More information can be found in documentation after registration.`,
  CommunicationSent: `This is a defined API endpoint within the tenant's application that is called by ${APP_NAME} when any communication has been sent to tenant users via email or sms. It delivers a record of the sent communication to a tenant user. More information can be found in documentation after registration. `,
  Signature: `Optional signature appended to the end of any sms or email.`,
  FreeDefault: `Optional subscription that is applied after a primary subscription becomes delinquent and is subsequently canceled.`,

  // SPR-011 T-005: trial-offer modal field help. The offer-type and application-mode text surface the
  // EVO-003 §2 / EVO-002 "Good for" descriptions.
  OfferType: `The behavioral trigger that gates who is eligible to see this offer.
Entry / Welcome: first-time buyers of this product.
Retention / Save-at-Cancel: shown to an active subscriber who tries to cancel.
Seasonal: eligible only within the campaign date window below.
Cross-sell: shown to customers who already own the qualifying product below.
Custom: no gating — always eligible.`,
  DiscountMode: `How the discount is applied over time.
Single term: one discounted block of the length set below, charged once, then renews at full price. Good for "$1 for 3 months" (one $1 block) or "$0 for 14 days".
Recurring per period: the discount applies to N consecutive billing periods at the product's own term, then reverts to full price. Good for "20% off for 6 months" or "$1/month for 3 months".`,
  RecurringPeriods: `The number of consecutive billing periods (N) the discount applies to before the subscription reverts to full price. Must be at least 2 — use Single term for a one-off discount.`,
  OfferDiscountType: `Fixed charges a specific discounted price for the offer. Percentage takes a percent off the product's price.`,
  OfferDiscountPercent: `The percent taken off the product's price for each discounted charge (1 to 100).`,
  OfferPrice: `The fixed discounted price, in pennies, charged for the offer.`,
  OfferDurationType: `The unit of the discounted block's length (used for Single term). Recurring per period ignores this and uses the product's own billing term.`,
  OfferDurationAmount: `The length of the discounted block, in the duration unit above (used for Single term). Recurring per period ignores this and uses the product's own billing term.`,
  DaysSinceLastOffer: `The minimum number of days that must pass since a customer last took a trial offer for this product before they become eligible for an offer on it again.`,
  QualifyingProduct: `For Cross-sell offers: the customer must already own this product to be eligible for the offer.`,
  CampaignStartsAt: `For Seasonal offers: the offer is only eligible on or after this campaign start date.`,
  CampaignEndsAt: `For Seasonal offers: the offer is only eligible on or before this campaign end date.`
}

const EXP_IDS = {
  Renew: `renew-tool-tip`,
  WarnCancel: `warn-cancel-tool-tip`,
  WarnRenewal: `warn-renew-tool-tip`,
  Grace: `grace-tool-tip`,
  EmailNotification: `email-tool-tip`,
  MobileNotification: `phone-tool-tip`,
  GetTenantUsers: `tenant-users-tool-tip`,
  CommunicationSent: `communication-tool-tip`,
  Signature: `signature-tool-tip`,
  FreeDefault: `free-default-tool-tip`,

  // SPR-011 T-005: trial-offer modal field anchors.
  OfferType: `offer-type-tool-tip`,
  DiscountMode: `discount-mode-tool-tip`,
  RecurringPeriods: `recurring-periods-tool-tip`,
  OfferDiscountType: `offer-discount-type-tool-tip`,
  OfferDiscountPercent: `offer-discount-percent-tool-tip`,
  OfferPrice: `offer-price-tool-tip`,
  OfferDurationType: `offer-duration-type-tool-tip`,
  OfferDurationAmount: `offer-duration-amount-tool-tip`,
  DaysSinceLastOffer: `days-since-last-offer-tool-tip`,
  QualifyingProduct: `qualifying-product-tool-tip`,
  CampaignStartsAt: `campaign-starts-tool-tip`,
  CampaignEndsAt: `campaign-ends-tool-tip`
}

const IMG_EXTENSIONS = [
  "png",
  "avif",
  "gif",
  "jpeg",
  "jpg",
  "png",
  "svg",
  "webp",
];
const ALLOWED_IMAGE_TYPES_CSV = IMG_EXTENSIONS.map(x => "." + x).join(",");

const PROD_DOMAINS = [
  "app.margot-okapi.com",
  "margot-okapi.azurewebsites.net"
]

const PRODUCT_STATUS =
{
  Pending: { value: 1, label: "Pending"},
  Paid: { value: 2, label: "Paid"},
  Failed: { value: 3, label: "Failed"},
  Refunded: { value: 4, label: "Refunded"},
  PartialRefund: { value: 5, label: "PartialRefund"},
  Delinquent: { value: 6, label: "Delinquent"},
  Expired: { value: 7, label: "Expired"}
};

const SAVE_BUTTON_CONTAINER_CLASS = {
  default: "w-60 pb-4 px-4",
  fit: "w-fit"
};

const constants = {
  APP_NAME,
  APP_SLOGAN,
  APP_PRIMARY_COLOR,
  APP_LOGO,
  DOCS_LINK,
  DISPLAY_PER_PAGE,
  DEV_DOMAIN,
  DURATION_TYPE,
  DURATION_TYPES,
  DURATION_TYPES_OPT_PLURALITY,
  DISCOUNT_TYPE,
  DISCOUNT_TYPES,
  DISCOUNT_MODE,
  DISCOUNT_MODES,
  EXP_IDS,
  EXPLANATIONS,
  INTERVAL_TYPES,
  MAX_PAYMENT_TYPES,
  NOTIFICATION_TYPES,
  OFFER_TYPE,
  OFFER_TYPES,
  PRICING_MODEL,
  PRICING_MODELS,
  PRODUCT_TYPE,
  PRODUCT_TYPES,
  SALES_INTERVAL_IDS,
  SALES_INTERVAL_TYPES,
  SORT_DIRECTIONS,
  SYS_TENANT_TABS,
  ROLES,
  ROLE_IDS,
  MIME_TYPES,
  MARKT_ADDRESS,
  US_TIMEZONES,
  MARKT_MONTHLY_MEMBERSHIP_ID,
  REFUND_REASONS,
  REGISTRATION_STEPS,
  STEPS_LIST,
  ALLOWED_IMAGE_TYPES_CSV,
  IMG_EXTENSIONS,
  PROD_DOMAINS,
  PRODUCT_STATUS,
  SAVE_BUTTON_CONTAINER_CLASS
};

export default constants;
